import { render, staticRenderFns } from "./UnpublishedNewsDetail.vue?vue&type=template&id=444a05ce&scoped=true&"
import script from "./UnpublishedNewsDetail.vue?vue&type=script&lang=js&"
export * from "./UnpublishedNewsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444a05ce",
  null
  
)

export default component.exports